import { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@components/Tooltip';
import { MultiSelect } from '@components/MultiSelect';
import { useTranslation } from '@hooks';

const MultiSelectWithIcon = styled(MultiSelect)({
    '& .MuiSelect-outlined': {
        paddingRight: '60px !important',
    },
    '& .MuiInputBase-adornedEnd': {
        paddingRight: 0,
    },
});

const TriggerEventsSelect = forwardRef((props, ref) => {
    const { t } = useTranslation();

    return (
        <MultiSelectWithIcon
            ref={ref}
            label={t('CampaignsPage.triggerEvent')}
            fullWidth
            countable
            required
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end" sx={{ position: 'absolute', right: '30px' }}>
                        <Tooltip enterTouchDelay={0} title={t('CampaignsPage.triggerExplanation')} placement="top">
                            <IconButton size="small">
                                <HelpIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                        </Tooltip>
                    </InputAdornment>
                ),
            }}
            {...props}
        />
    );
});

TriggerEventsSelect.displayName = 'TriggerEventsSelect';

export default TriggerEventsSelect;
